import { render, staticRenderFns } from "./optionCustom.vue?vue&type=template&id=833b966a&scoped=true&"
import script from "./optionCustom.vue?vue&type=script&lang=js&"
export * from "./optionCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "833b966a",
  null
  
)

export default component.exports